import React from 'react'
import ErrorBoundary from "../../../error-boundary"

type Props = {
    className?  : string

    size        : 28 | 24
    fieldId?    : string // either pass fieldId
    field?      : any // or full config

    selected    : boolean
    disabled    : boolean
    displayIcon : boolean

    onClick     : callback
}

// const debug = "FieldButton"
const debug = false

// Make it react component to allow hints in future
// OR we need new hint for function components

export default class FieldButton extends React.Component<Props> {

    static defaultProps = {
        size        : 28,
        selected    : false,
        disabled    : false,
        displayIcon : false
    }

    onClick = () => {
        if (this.props.disabled) return

        this.props.onClick()
    }

    render() {
        debug && console.log(debug, "render", this.props.fieldId, this.props.field, this.props.fieldId ? gd.const.fields[this.props.fieldId] : null)

        let field = this.props.field ? this.props.field : this.props.fieldId ? gd.const.fields[this.props.fieldId] : null

        // this is custom field
        if (!field) {
            const customField = gd.session.customFields.get(this.props.fieldId!);

            debug && console.log(debug, "render customField", this.props.fieldId, customField)

            if (customField) {
                // create custom field config from custom field
                field = {
                    title       : customField.name,
                    label       : customField.name,
                    icon        : customField.icon,
                    columnId    : null,
                    description : '',
                    group       : 'custom-fields' // CUSTOM_FIELDS:      'custom-fields',
                }
            }
        }

        // fallback
        if (!field) {
            console.error("#88dhs No field found", this.props)
            return false
        }

        const buttonClass = Classes("ui5-field-pill s-{0} ".f(this.props.size),this.props.className, {
            'disabled'  : this.props.disabled,
            'selected'  : this.props.selected
        })

        return (
            <ErrorBoundary>
                <div className={buttonClass} onClick={this.onClick}>
                    {/*{this.props.hint && <HintPopover parent={this} hint={this.props.hint} />}*/}
                    {this.props.displayIcon && field.icon &&
                        <div className={Classes("icon", field.icon)} />}
                    {field.label || field.title}
                </div>
            </ErrorBoundary>
        )
    }
}